<script setup lang="ts">
import type { CollapsibleTriggerProps } from "reka-ui"
import { CollapsibleTrigger } from "reka-ui"

const props = defineProps<CollapsibleTriggerProps>()
</script>

<template>
    <CollapsibleTrigger v-bind="props">
        <slot />
    </CollapsibleTrigger>
</template>
